import styled, { createGlobalStyle } from 'styled-components';
import { Container } from 'reactstrap';
import { Title } from '../../components/Title/style';
import colors from '../../includes/colors';

export const GlobalStyle = createGlobalStyle``;

export const CustomTitle = styled(Title)`
  font-size: 1.125rem;
  @media (min-width: 480px) and (max-width: 575px) {
    font-size: 1.5rem;
  }
`;

export const BannerContainer = styled(Container)`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  height: 100%;
`;
export const Banner = styled.div`
  padding-top: 1.2rem;
  padding-bottom: 1.2rem;
  position: relative;
  height: 200px;
  width: 100%;
  max-width: 1250px;
  margin: 0 auto;
  background-size: cover;
  background-image: ${({ image }) => `url(${image})`};
  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(180deg, transparent 25%, rgba(0, 118, 206, 0.66));
  }

  @media (min-width: 480px) {
    height: 260px;
  }

  @media (min-width: 768px) {
    height: 360px;
  }

  @media (min-width: 992px) {
    margin-bottom: -4.35rem;
    height: 500px;
    padding-bottom: 6.2rem;
  }
`;

export const BannerText = styled.div`
  color: ${colors.white};
  z-index: 1;

  @media (min-width: 768px) {
    flex-basis: 50%;
  }
`;
export const BannerTitle = styled.h1`
  font-size: 1.75rem;
  font-weight: 300;
  margin-bottom: 0;
  line-height: 1.75rem;
  @media (min-width: 480px) {
    font-size: 2rem;
  }

  @media (min-width: 576px) {
    line-height: 2.25rem;
  }

  @media (min-width: 768px) {
    line-height: 2.5rem;
  }

  @media (min-width: 992px) {
    font-size: 2.65rem;
  }
`;
export const BannerDescription = styled.p`
  font-size: 0.75rem;
  margin-bottom: 0;
  margin-left: 3px;
  letter-spacing: 1.5px;
  line-height: 1.25rem;
  font-weight: 400;

  @media (min-width: 992px) {
    font-size: 1rem;
  }
`;

export const BannerSignIn = styled.div`
  background: ${colors.white};
  position: fixed;
  width: 100%;
  z-index: 4;
  left: 0;
  top: 0;
  padding-top: 66px;
  display: ${props => props.isOpenSigninBox ? 'block' : 'none'};

  @media (min-width: 768px) {
    width: auto;
    position: relative;
    display: block;
    padding-top: 0;
  }

  @media (min-width: 992px) {
    width: 395px;

    &.language-canada {
      top: -100px;
    }
  }
`;
